import { useBridge, useLocalStorage, useSessionStorage } from '@acsbe/commons';
// import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useRouterContext(isDevMode: boolean) {
  const { t } = useTranslation();
  const session = useSessionStorage();
  const local = useLocalStorage();

  const ctx = useMemo(
    () => ({
      t,
      session,
      local,
      isDevMode,
    }),
    [
      t,
      session,
      local,
      isDevMode,
    ],
  );
  return ctx;
}

export type RouterContext = ReturnType<typeof useRouterContext>;
